import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Manual from '@/components/Manual';
export default {
  name: 'App',
  components: {
    Manual: Manual
  },
  data: function data() {
    return {
      isRouterAlive: true,
      manualVisible: !!Number(localStorage.getItem('firstLoginFlag'))
    };
  },
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _window$_QIANKUN_PROP;

      (_window$_QIANKUN_PROP = window._QIANKUN_PROPS_) === null || _window$_QIANKUN_PROP === void 0 ? void 0 : _window$_QIANKUN_PROP.setGlobalState({
        microMounting: true
      });
    });
  },
  methods: {
    reload: function reload() {
      var _this = this;

      this.$root.isRouterAlive = false;
      this.$nextTick(function () {
        _this.$root.isRouterAlive = true;
      });
    },
    handleClose: function handleClose() {
      this.manualVisible = false;
      localStorage.removeItem('firstLoginFlag');
    }
  }
};